import api from './utils/api.js';

const actions = {
  getInit(context) {
    let params = {
      requiredData: {
        getSitesV3: 1,
        getHistoryPanelHTMLV3: 1,
        getPluginsAndThemesV3: 1,
        getGroupsSitesV3: 1,
        getSitesUpdatesV3: 1,
        getFavouritesPluginsAndThemesV3: 1,
        getClientUpdateAvailableSiteIDs: 1,
        getAppInfoV3: 1,
        getSettingsAllV3: 1,
        initialCheckUpdateV3: 1,
        getMenusV3:1,
        getAddonAlertCount:1,
        getEditSiteMenu:1,
        getSettingsMenu:1,
        getSiteInfoMenu:1,
        getCurrentUserInfoV3:1,
        getInitPageV3:1,
      },
      stopAjaxLoading: true
    };
    return api
      .post(params)
      .then(response => {
        context.commit('SET_SITES', response.data.getSitesV3);
        context.commit('SET_GROUPS', response.data.getGroupsSitesV3);
        context.commit('SET_SITES_UPDATES', response.data.getSitesUpdatesV3);
        context.commit(
          'SET_FAVORITES',
          response.data.getFavouritesPluginsAndThemesV3
        );
        context.commit(
          'SET_PLUGINS_AND_THEMES',
          response.data.getPluginsAndThemesV3
        );
        context.commit(
          'SET_PANEL_HISTORY',
          response.data.getHistoryPanelHTMLV3
        );
        context.commit(
          'SET_CLIENT_PLUGIN_UPDATES',
          response.data.getClientUpdateAvailableSiteIDs
        );
        context.commit('SET_SETTINGS', response.data.getSettingsAllV3);
        context.commit('SET_APPINFO', response.data.getAppInfoV3);
        context.commit(
          'SET_PANEL_UPDATE_INFO',
          response.data.initialCheckUpdateV3
        );
        context.commit(
          'SET_ADDONS_UPDATE_INFO',
          response.data.getAddonAlertCount
        );
        context.commit(
          'SET_MENUS',
          response.data.getMenusV3
        );
        context.commit(
          'SET_EDIT_SITE_MENU',
          response.data.getEditSiteMenu
        );
        context.commit(
          'SET_SETTINGS_MENU',
          response.data.getSettingsMenu
        );
        context.commit(
          'SET_SITEINFO_MENU',
          response.data.getSiteInfoMenu
        );
        context.commit(
          'SET_CURRENT_USERINFO',
          response.data.getCurrentUserInfoV3
        );
        context.commit(
          'SET_INIT_PAGE',
          response.data.getInitPageV3
        );
      })
      .catch(error => {
        context.commit('API_FAILURE', error);
        return Promise.reject(error);
      });
  },
  getPanelHistory(context, details) {
    let isStoppedHistoryCheckCall = context.getters.isStoppedHistoryCheckCall;
     if (isStoppedHistoryCheckCall === true) {
       return Promise.resolve(false);
     }
    let params = {
      requiredData: {
        getHistoryPanelHTMLV3: 1,
      },
      stopAjaxLoading: true,
    };
    if (details.onActionID) {
      params.requiredData.getHistoryPanelDetailedHTMLV3 = {actionid: details.onActionID};
    }
    context.commit(
      'STOP_HISTORY_CHECK_CALL',
      true
    );
    return api
      .post(params)
      .then(response => {
        context.commit(
          'SET_PANEL_HISTORY',
          response.data.getHistoryPanelHTMLV3
        );
        context.commit(
          'STOP_HISTORY_CHECK_CALL',
          false
        );
        return Promise.resolve(response);
      })
      .catch(error => { context.commit('API_FAILURE', error)
             context.commit(
               'STOP_HISTORY_CHECK_CALL',
               false
             );
       });
  },
  sendAction(context, payload) {
    if (payload.ignorePanelHistory) {
      delete payload.ignorePanelHistory;
    } else {
      if (typeof payload.requiredData === 'undefined') {
        payload.requiredData = {};
      }
      payload.requiredData['getHistoryPanelHTMLV3'] = 1;
    }
    return api
      .post(payload)
      .then(response => {

        if (response.data && response.data.getHistoryPanelHTMLV3) {
          context.commit(
            'SET_PANEL_HISTORY',
            response.data.getHistoryPanelHTMLV3
          );
        }
        return Promise.resolve(response);
      })
      .catch(error => {

        context.commit('API_FAILURE', error);
      });
  }
};

export default actions;
